<template>
  <div class="lotti-admin-container">
    Admin
  </div>
</template>

<script>
import {router} from '../../main.js';

export default {
  data() {
    return {
     
    }
  },
  methods: {

  },
  mounted() {

  }
}

</script>